import { HousingFormPageHeaderCard } from '@app/components/blocks/card/HousingFormPageHeaderCard'
import { Title } from '@app/components/core/typography/Title'
import { PageLayout } from '@app/pages/layout/PageLayout'
import { useClient } from '@based/sdk/react'
import { useEffect, useState, useMemo } from 'react'
import { useTranslations } from '@i18n/useLanguage'
import Row from '@app/components/layout/Row'
import useTransform from '@app/util/useTransform'
import { Card } from '@app/components/blocks/card/Card'
import Column from '@app/components/layout/Column'
import { fullName } from '@app/util/helpers'
import { TabContent } from './TabContent'
import { HousingFormPagePopularHousingFormsCard } from './sections/HousingFormPagePopularHousingFormsCard'
import { ItemListCardItem } from '@app/components/blocks/card/ItemListCard'
import { ViewHousingFormModel } from 'functions/app/housing-form/view'
import useMediaQuery from '@app/util/useMediaQuery'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'

export type HousingFormPageProps = {
  id: string
}

export const HousingFormPage = ({ id }: HousingFormPageProps) => {
  const client = useClient()
  const [housingForm, setHousingForm] = useState<ViewHousingFormModel>()
  const t = useTranslations().app
  const transformStyle = useTransform()
  const isMobile = useMediaQuery()
  const [, setLocation] = useLocation()

  useEffect(() => {
    const subscription = client
      .query('view-housing-form', { id })
      .subscribe((p) => setHousingForm(p))

    return () => {
      subscription()
    }
  }, [client, id])

  const excludeIds = useMemo(() => [housingForm?.id], [housingForm?.id])

  if (!housingForm) {
    return <div>{t.housingFormPage.loading}</div>
  }

  return (
    <PageLayout gap="2rem">
      <Row
        gap="3rem"
        style={{
          alignItems: 'flex-start',
          ...transformStyle,
        }}
      >
        <Column style={{ flex: 1, width: '100%' }} gap="1.5rem">
          <HousingFormPageHeaderCard
            style={{ flex: 1 }}
            housingForm={housingForm}
          />
          <TabContent housingForm={housingForm} />
        </Column>

        {!isMobile && (
          <Column style={{ flex: '0 1 23rem', minWidth: '23rem' }}>
            <HousingFormPagePopularHousingFormsCard excludeIds={excludeIds} />

            {housingForm?.ambassador && (
              <Card>
                <Title.H5>{t.housingFormPage.ambassadorCard.title}</Title.H5>
                <ItemListCardItem
                  item={{
                    image: housingForm?.ambassador?.avatar?.src || '',
                    title: fullName(housingForm?.ambassador),
                    onClick: () =>
                      setLocation(
                        pages.profile(housingForm?.ambassador?.handle),
                      ),
                  }}
                />
              </Card>
            )}
          </Column>
        )}
      </Row>
    </PageLayout>
  )
}
